import instance from "../utils/network";

export interface SearchBannerResponse {
  id: number;
  title: string;
  subTitle: string;
  url: string;
  type: string;
  order: number;
  startAt: string;
  closeAt: string;
  createdAt: string;
}

export function getSearchBanner(): Promise<SearchBannerResponse[]> {
  return instance.get(`/nest/search-banner`);
}
